import domService from '@/services/domService';

const HW_H_VARIABLE = '--hw-h';

export const setHwHeightCssVariable = (el, height) =>
    domService.setCssVariable(HW_H_VARIABLE, `${height}px`, {element: el});
export const getHwHeight = () => domService.getCssVariable(HW_H_VARIABLE, {asFloat: true});
